import { Image, ImageProps } from '@chakra-ui/react'
import React from 'react'

export const AssessmentIcon = (props: ImageProps) => (
  <Image mr={1} opacity={0.7} width="20px" src="/images/assessment.svg" {...props} />
)
